<template>
    <u-select-outlined-tile v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-select-outlined-tile>
</template>

<script>
import USelectOutlinedTile from "@/components/publish/styles/forms/u-select-outlined-tile.vue";

export default {
    props: {},
    components: {
        USelectOutlinedTile,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
